module.exports = __webpack_public_path__ + "img/img23.effb7541.svg";